import { APEX_API_URL } from '@/constants';
import { isServerSide } from '@/helpers';
import { IProduct } from '@/interfaces/product';
import { INextAuthSessionModel } from '@/interfaces/authentication';
import { IAddToCartItem, IGetCartProduct } from '@/interfaces/cart';
import { serverSideAxiosInstance } from '@/utils/serverSideAxiosClientWithInterceptor';
import axiosInstanceFromComponent from '../components/AxiosInterceptorComponent';
import { IAddToWishlist, IWishlist } from '@/interfaces/wishlist';

let axiosInstance = serverSideAxiosInstance;
if (!isServerSide()) {
  axiosInstance = axiosInstanceFromComponent;
}

export const addToWishlist = async (item: IAddToWishlist): Promise<IProduct> => {
  const response = await axiosInstance.post(`${APEX_API_URL}/api/wishlist`, item);
  return response.data;
};

export const getWishlist = async (session?: INextAuthSessionModel | null): Promise<IWishlist> => {
  const response = await axiosInstance.get(`${APEX_API_URL}/api/wishlist`, {
    headers: {
      Authorization: 'Bearer ' + session?.accessToken,
    },
  });
  return response.data;
};
export const deleteFromWishlist = async (id: string): Promise<any> => {
  const body = {
    productId: id,
    //  wishlistItemId: id,
  };
  const response = await axiosInstance.delete(`${APEX_API_URL}/api/wishlist`, { data: body });
  return response.data;
};
